module.exports = __webpack_public_path__ + "img/carousel-clientes-14.2e396c53.png";